import { AIButtonContainedLight as AIButtonContainedLightButton } from '../../AIButton'
import { BUTTON_ICON_SIZES, BUTTON_SIZES } from '../Buttons'
import { Container } from '../Container'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function AIButtonContainedLight() {
  return (
    <>
      <Container label='AI Button, contained light, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedLightButton
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, disabled, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedLightButton
            disabled
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedLightButton
            isLoading
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, with pre icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedLightButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, with pre icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedLightButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, with post icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedLightButton
            afterIconProps={{ Icon: EditIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, with post icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedLightButton
            isLoading
            afterIconProps={{ Icon: EditIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, with skeleton, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonContainedLightButton
            isSkeleton
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedLightButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedLightButton
            disabled
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedLightButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, icon, with skeleton, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedLightButton
            isSkeleton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, circle icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedLightButton
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, circle icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedLightButton
            disabled
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, circle icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedLightButton
            isCircle
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, contained light, circle icon, with skeleton, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonContainedLightButton
            isCircle
            isSkeleton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
